import { ChefHat, Users, Award, Utensils } from 'lucide-react';

const About = () => {
  return (
    <div className="animate-fade-up">
      {/* Hero Section */}
      <div className="bg-[#ea384c] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Our Story</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Founded with a passion for delivering exceptional culinary experiences,
            our cloud kitchen brings together talented chefs and innovative cooking
            techniques to create memorable meals.
          </p>
        </div>
      </div>

      {/* Values Section */}
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6">Our Values</h2>
              <div className="space-y-6">
                {[
                  {
                    icon: ChefHat,
                    title: "Culinary Excellence",
                    description: "Our expert chefs craft each dish with precision and passion"
                  },
                  {
                    icon: Users,
                    title: "Customer First",
                    description: "Your satisfaction is our top priority in everything we do"
                  },
                  {
                    icon: Award,
                    title: "Quality Ingredients",
                    description: "We source only the finest ingredients for our dishes"
                  },
                  {
                    icon: Utensils,
                    title: "Innovation",
                    description: "Constantly evolving our menu to bring you exciting flavors"
                  }
                ].map((value, index) => (
                  <div key={index} className="flex items-start">
                    <div className="flex-shrink-0">
                      <value.icon className="h-6 w-6 text-primary" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-semibold mb-1">{value.title}</h3>
                      <p className="text-gray-600">{value.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-gray-100 rounded-lg p-8">
              <h3 className="text-2xl font-bold mb-4">Our Kitchen</h3>
              <p className="text-gray-600 mb-6">
                Our state-of-the-art cloud kitchen facility is equipped with the latest
                culinary technology and maintains the highest standards of hygiene and
                food safety. We take pride in our:
              </p>
              <ul className="space-y-3 text-gray-600">
                <li>• Modern cooking equipment</li>
                <li>• Strict quality control processes</li>
                <li>• Professional kitchen staff</li>
                <li>• Efficient delivery system</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;